import { IconType } from "react-icons";
import { IoHomeOutline } from "react-icons/io5";
import {
    MdOutlineForwardToInbox,
    MdOutlineLocationCity,
    MdOutlineQuestionMark,
    MdOutlineSettings,
} from "react-icons/md";
import { BsBox2, BsBell, BsLayers } from "react-icons/bs";
import { BiCategoryAlt } from "react-icons/bi";
import { TbPolygon, TbTopologyStar3 } from "react-icons/tb";
import { FiUsers } from "react-icons/fi";
import { CiMoneyCheck1 } from "react-icons/ci";
import { VscSymbolClass } from "react-icons/vsc";

interface Link {
    title: string;
    path: string;
    icon?: IconType | null;
}

export const adminLinks: Link[] = [
    {
        title: "الرئيسية",
        path: "/",
        icon: IoHomeOutline,
    },
    {
        title: "ادارة الطلبات",
        path: "/orders",
        icon: MdOutlineForwardToInbox,
    },
    {
        title: "ادارة المنتجات",
        path: "/products",
        icon: BsBox2,
    },
    {
        title: "ادارة التصنيفات",
        path: "/categories",
        icon: BiCategoryAlt,
    },
    {
        title: "ادارة المدن",
        path: "/cities",
        icon: MdOutlineLocationCity,
    },
    {
        title: "ادارة المناطق",
        path: "/areas",
        icon: TbPolygon,
    },
    {
        title: "ادارة المستخدمين",
        path: "/users",
        icon: FiUsers,
    },
    {
        title: "ادارة الاشعارات",
        path: "/notification",
        icon: BsBell,
    },
    {
        title: "ادارة الموزعين",
        path: "/deliverers",
        icon: TbTopologyStar3,
    },
    {
        title: "سجل عمليات الدفع",
        path: "/transactions",
        icon: CiMoneyCheck1,
    },
    {
        title: "تصنيفات المشاكل",
        path: "/problems-categories",
        icon: VscSymbolClass,
    },
    {
        title: "ادارة الاسئلة الاكثر تكرارا",
        path: "/common-questions",
        icon: MdOutlineQuestionMark,
    },
    {
        title: "ادارة الاعلانات  ",
        path: "/banners",
        icon: BsLayers,
    },
    {
        title: "الضبط",
        path: "/settings",
        icon: MdOutlineSettings,
    },
];
